import { Box } from '@mui/material'
import { Loader } from 'components/Loader'
import { ProtectedRoute } from 'components/ProtectedRoute'
import { LoginPage } from 'pages/login'
import { basename } from 'path'
import { Suspense, lazy } from 'react'
import { Navigate, RouterProvider, createBrowserRouter } from 'react-router-dom'

const LessonsPage = lazy(() =>
  import('pages/lessons/LessonsPage').then((module) => ({
    default: module.LessonsPage
  }))
)

const CreateLessonPage = lazy(() =>
  import('pages/lessons/CreateLessonPage/CreateLessonPage').then((module) => ({
    default: module.CreateLesson
  }))
)

const QuestionsPage = lazy(() =>
  import('pages/questions/QuestionsPage').then((module) => ({
    default: module.Questions
  }))
)

const CreateQuestionPage = lazy(() =>
  import('pages/questions/CreateQuestionPage/CreateQuestionPage').then(
    (module) => ({
      default: module.CreateQuestionPage
    })
  )
)

const HomepagePage = lazy(() =>
  import('pages/homepage/Homepage').then((module) => ({
    default: module.Homepage
  }))
)

const CoursesPage = lazy(() =>
  import('pages/courses/').then((module) => ({
    default: module.CoursesPage
  }))
)

const SingleCoursePage = lazy(() =>
  import('pages/courses/SingleCourse/').then((module) => ({
    default: module.SingleCoursePage
  }))
)

const CourseTeachersPage = lazy(() =>
  import('pages/courses/CourseTeachersPage/').then((module) => ({
    default: module.CourseTeachersPage
  }))
)

const CourseStudentsPage = lazy(() =>
  import('pages/courses/CourseStudentsPage/').then((module) => ({
    default: module.CourseStudentsPage
  }))
)

const OrdersPage = lazy(() =>
  import('pages/orders/').then((module) => ({
    default: module.OrdersPage
  }))
)

const ProfilePage = lazy(() =>
  import('pages/profile/').then((module) => ({
    default: module.ProfilePage
  }))
)

const SingleStudentPage = lazy(() =>
  import('pages/students/SingleStudentPage').then((module) => ({
    default: module.SingleStudentPage
  }))
)

const PracticePage = lazy(() =>
  import('pages/practice/').then((module) => ({
    default: module.PracticeQuestionsPage
  }))
)

const TestPage = lazy(() =>
  import('pages/test').then((module) => ({
    default: module.TestPage
  }))
)

const HistoryPage = lazy(() =>
  import('pages/dashboard/HistoryPage').then((module) => ({
    default: module.HistoryPage
  }))
)
const ResultsPage = lazy(() =>
  import('pages/results').then((module) => ({
    default: module.ResultsPage
  }))
)

const DashboardPage = lazy(() =>
  import('pages/dashboard').then((module) => ({
    default: module.DashboardPage
  }))
)

const DashboardPerformancePage = lazy(() =>
  import('pages/dashboard/PerformancePage').then((module) => ({
    default: module.DashboardPerformancePage
  }))
)

export const router = createBrowserRouter([
  {
    path: `${process.env.REACT_APP_DOMAIN}`,
    element: <Navigate to={`${process.env.REACT_APP_DOMAIN}/`} replace />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/practice-ai',
    element: (
      // <ProtectedRoute>
      <PracticePage />
      // </ProtectedRoute>
    )
  },
  {
    path: '/theory-test',
    element: (
      <ProtectedRoute>
        <TestPage />
      </ProtectedRoute>
    )
  },
  {
    path: `${process.env.REACT_APP_DOMAIN}/road-sign-board`,
    element: (
      <Navigate
        to={`${process.env.REACT_APP_DOMAIN}/road-sign-board/`}
        replace
      />
    )
  },
  {
    path: `${process.env.REACT_APP_DOMAIN}/articles`,
    element: (
      <Navigate to={`${process.env.REACT_APP_DOMAIN}/articles/`} replace />
    )
  },
  {
    path: '/articles',
    element: (
      <ProtectedRoute>
        <Navigate to={`${process.env.REACT_APP_DOMAIN}/articles/`} replace />
      </ProtectedRoute>
    )
  },
  {
    path: '*',
    element: (
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    )
  },
  {
    path: '/students/:id',
    element: (
      <ProtectedRoute>
        <SingleStudentPage />
      </ProtectedRoute>
    )
  },
  {
    path: '/history',
    index: true,
    element: (
      <ProtectedRoute>
        <Navigate to="/dashboard/history" replace />
      </ProtectedRoute>
    )
  },
  {
    path: '/history/:id',
    element: (
      <ProtectedRoute>
        <ResultsPage />
      </ProtectedRoute>
    )
  },
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute>
        <DashboardPage />
      </ProtectedRoute>
    ),
    children: [
      {
        path: 'history',
        element: (
          <ProtectedRoute>
            <HistoryPage />
          </ProtectedRoute>
        )
      },
      {
        path: 'performance',
        element: (
          <ProtectedRoute>
            <DashboardPerformancePage />
          </ProtectedRoute>
        )
      },
      {
        path: '*',
        index: true,
        element: (
          <ProtectedRoute>
            <Navigate to="/dashboard/history" replace />
          </ProtectedRoute>
        )
      }
    ]
  }
])

export const AppRouter = () => {
  return (
    <Suspense
      fallback={
        <Box>
          <Loader />
        </Box>
      }
    >
      <RouterProvider router={router} />
    </Suspense>
  )
}
